/**
 * Converts all Set objects within a given object to arrays.
 * This function recursively traverses the object and converts any Set it encounters to an array.
 * @function convertSetsToArrays
 * @param {Record<string, unknown>} obj - The object to convert.
 */
export const convertSetsToArrays = (obj: Record<string, unknown>): void => {
  for (const key of Object.keys(obj)) {
    if (obj[key] instanceof Set) {
      obj[key] = Array.from(obj[key] as Set<unknown>);
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      convertSetsToArrays(obj[key] as Record<string, unknown>);
    }
  }
};
